/**
 * Route for `published-pentest-results`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PublishedPentestResultsPage } from "../features/published-pentest-results/PublishedPentestResultsPage";

export const publishedPentestResultsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/published-pentest-results",
	component: PublishedPentestResultsPage,
});

export default publishedPentestResultsRoute;
